
import { Component } from '@niknevis/vue-modules'
import AdminDepartmentBaseForm from '@/modules/department/components/admin/base/AdminDepartmentBaseForm.vue'
import { AdminDepartmentStoreUseCase } from '@/modules/department/use-cases/admin-department-store.use-case'

@Component
export default class AdminDepartmentCreateForm extends AdminDepartmentBaseForm {
  constructor(
    private readonly useCase: AdminDepartmentStoreUseCase
  ) {
    super()
  }

  protected get loadingState(): boolean {
    return this.loading || this.__loadingState || this.useCase.isLoading
  }

  protected onSubmit() {
    this.useCase.execute(this.requestData)
      .onSuccess(() => {
        this.$emit('success')
      })
  }
}
